export interface StatusEvent {
	id: string;
	startTime: string;
	endTime: string;
	description: StatusEventLanguage;
	title: StatusEventLanguage;
	type: StatusEventType;
	platform: PlatformTenant;
}

export interface StatusEventLanguage {
	[language: string]: string;
}

export interface StatusEventDisplay {
	currentIncidents: StatusEvent[];
	pastIncidents: StatusEvent[];
	plannedUpgrades: StatusEvent[];
	lang: string;
	status: StatusPageState;
}

export enum StatusEventType {
	plannedmaintenance = 'plannedmaintenance',
	incident = 'incident',
}

export enum PlatformTenant {
	seltronhome = 'seltronhome',
	heatnext = 'heatnext',
}

export enum StatusPageState {
	Fetching,
	Success,
	Disrupted,
}

export enum LegalPageState {
	Terms,
	TermsPartners,
	Privacy,
	ClausiusBT,
	Oeg,
	Silvertec,
}
